import React from 'react';

// Soft banner used at the top of inner pages (Leistungen / Preise / Galerie / Kontakt / Booking)
const PageBanner = ({ tag, title, subtitle }) => {
  return (
    <section
      className="relative pt-36 pb-16 lg:pt-44 lg:pb-20"
      style={{
        background:
          'linear-gradient(135deg, #fdf2f5 0%, #fbe6ee 50%, #f7d9e5 100%)',
      }}
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
        {tag && (
          <p className="text-[#b54e7d] text-xs md:text-sm mb-4 tracking-[0.3em] uppercase font-medium">
            {tag}
          </p>
        )}
        <h1
          className="font-display text-[#5a1d3b]"
          style={{
            fontSize: 'clamp(2rem, 3.6vw, 3.25rem)',
            fontWeight: 500,
            lineHeight: 1.18,
            letterSpacing: '-0.01em',
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-gray-600 mt-5 max-w-2xl mx-auto text-[15px] md:text-base leading-relaxed">
            {subtitle}
          </p>
        )}
        <div className="w-16 h-px bg-[#c4477a]/40 mx-auto mt-8" />
      </div>
    </section>
  );
};

export default PageBanner;
